import { useEffect, useState } from "react";

export function applyStoredTheme() {
  try {
    const s = localStorage.getItem("cts-theme");
    if (s) document.documentElement.setAttribute("data-theme", s);
  } catch (e) { console.debug("theme read failed", e); }
}

export function useTheme() {
  const [theme, setTheme] = useState(
    () => document.documentElement.getAttribute("data-theme") || "light"
  );
  useEffect(() => {
    applyStoredTheme();
    setTheme(document.documentElement.getAttribute("data-theme") || "light");
  }, []);
  const toggle = () => {
    const cur = document.documentElement.getAttribute("data-theme");
    const nx = cur === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", nx);
    setTheme(nx);
    try { localStorage.setItem("cts-theme", nx); } catch (e) { console.debug("theme persist failed", e); }
  };
  return { theme, toggle };
}
